import React from "react";
import { Badge } from "reactstrap";
import { ContactListType } from "../../../../../Types/MessengerType";
import { dynamicImage, Image } from "../../../../../Utils";
import SearchNotFoundClass from "../../../../CommonComponents/SearchNotFound/SearchNotFoundClass";
import SvgIcon from "../../../../CommonComponents/SvgIcon";

const ContactList: React.FC<ContactListType> = ({ FilteredItems }) => {
  return (
    <ul className="chat-main">
      {FilteredItems.length !== 0 ? (
        FilteredItems.map((item, index) => (
          <li className={item.active} key={index}>
            <div className="chat-box">
              <div className={`profile ${item.class}`}>
                <Image className="bg-img img-fluid" src={dynamicImage(item.avatar)} alt="Avatar" />
              </div>
              <div className="details">
                <h4>{item.title}</h4>
                <h5 className={`${item.textSvg && "font-primary"}`}>
                  {item.svg && <SvgIcon className="fill-primary" iconId={item.svg} />}
                  {item.textSvg && <SvgIcon className="fill-primary" iconId="gallery" />}
                  {item.text}
                </h5>
              </div>
              <div className="date-status">
                <h6>{item.date}</h6>
                {item.badge && (<Badge color="primary" className="sm">8</Badge>)}
                {item.status && <h6 className={`font-${item.color} status`}> {item.status}</h6>}
                {item.image && (<span><Image className="img-30" src={dynamicImage("gif/Loader.gif")} alt="gif" /></span>)}
                {item.svgIcon && <SvgIcon className="fill-danger" iconId="danger" />}
              </div>
            </div>
          </li>
        ))
      ) : (
        <SearchNotFoundClass word="Sorry, Not Found Any Search." />
      )}
    </ul>
  );
};

export default ContactList;
